<emm-management-layout>
  <emm-search-filter
    [addDialog]="false"
    [attr.data-testid]="'item_search_bar'"
    [displaySearchWithOptions]="false"
    [fields]="fields"
    [isAdminOrAuthor]="(this.isAdmin || this.isAuthor) && !isMMSAuthor"
    [isSuperAdmin]="this.isSuperAdmin"
    layout-center-header
    (filter)="onFilter($event)"
  ></emm-search-filter>
  <emm-generic-items-list
    [contextMenuActions]="itemsContextMenuActions"
    [disableContextActions]="anyLoading$ | async"
    [isReadOnly]="(isReadOnly$ | async) || isMMSAuthor"
    [isMmsAuthorOnly]="isMMSAuthor"
    [items]="items$ | async"
    layout-center-content
    (onSelectItem)="onSelectItem($event)"
  ></emm-generic-items-list>
  @if ((itemDetail$ | async); as item) {
    <emm-management-attributes-header
      layout-right-header
      [name]="item.name"
      [tag]="item.tag"
      [type]="item.itemType"
    ></emm-management-attributes-header>
  }
  @if ((itemDetail$ | async)) {
    <emm-items-form
      #form
      layout-right-content
      [previousAttributeGroups]="previousAttributeGroups$ | async"
      (attributeGroupSelected)="onAttributeGroupSelected($event)"
    ></emm-items-form>
  }
  <context-menu #nodeMenu [disabled]="(isReadOnly$ | async) || isMMSAuthor">
    Delete
    <ng-template contextMenuItem (execute)="onDeleteItem(null)">
      <mat-icon>delete</mat-icon>
      <span [attr.data-testid]="'refresh_items'">Delete</span>
    </ng-template>
  </context-menu>
</emm-management-layout>
